import {
  SET_MY_ALERT_NOTIFICATION_DETAILS,
  SET_DELETE_ALERT_NOTIFICATION_DETAILS,
  SET_DELETE_ALL_ALERTS,
  SET_DELETE_ALL_NOTIFICATIONS,
  SET_IS_ALERT_NOTIFICATION_API_CALLED
  } from "./AlertNotificationType";
  
  const initialState = {
    myAlertNotificationDetails: {},
    DeleteAlertNotificationDetails: false,
  };
  
  const AlertAndNotifications = (state = initialState, action: any) => {
    switch (action.type) {
      case SET_MY_ALERT_NOTIFICATION_DETAILS:
        return {
          ...state,
          myAlertNotificationDetails: action.notificationdetails,
        };     
      case SET_DELETE_ALERT_NOTIFICATION_DETAILS:
        return {
          ...state,
          DeleteAlertNotificationDetails: action.deletenotificationdetails,
        };     
      case SET_DELETE_ALL_ALERTS:
        return {
          ...state,
          deleteAllAlerts: action.deleteAllAlerts,
        };
      case SET_DELETE_ALL_NOTIFICATIONS:
        return {
          ...state,
          deleteAllNotifications: action.deleteAllNotifications,
        }; 
      case SET_IS_ALERT_NOTIFICATION_API_CALLED:
        return {
          ...state,
          isAlertNotificationApiCalled: action.isAlertNotificationApiCalled,
        }; 
            
      default:
        return state;
    };
  }
  
  export default AlertAndNotifications;
  